import type { V2CreateAdminAgencyInput } from '@idc-forms/schemas/api-v2/admin-agencies'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateAgencyV2Mutation } from '../hooks/use-agency-v2-mutations'
import { AgencyV2Form } from './agency-v2-form'

type AgencyV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nueva agencia" contra la API v2: el mismo `AgencyV2Form` que la edición. */
export function AgencyV2CreatePanel({ onDone }: AgencyV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateAgencyV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminAgencyInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <AgencyV2Form
      submitLabel="Crear agencia"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
